export default __webpack_public_path__ + "static/project-c9de6969a6f8a44217dbf9b48f301bce.png";